import { autofill_click_log } from "./log";
import { campground_search, cgScrollToResults, send_autofill_search_and_handle_response } from "./page-scripts/index_scripts";
import { getSearchSuggestions, getSearchSuggestions_CIU } from "./util/autofill_scripts";
import { waitFor } from "./util/general_util";
import { loadingIcon } from "./util/mustache_templates";
import { reverseGeocode } from "./util/user_api";

if (window.location.pathname.includes("/campgroundInfoUpdate")) {
  //click #editCampgroundInfo automatically on load if urlparams direct=direct
  const urlParams = new URLSearchParams(window.location.search);
  $(document).ready(function() {
    if(urlParams.get("direct") == "direct"){
      $("#editCampgroundInfo").click();
      $("#editCampground_checkfor_selectedcamp_wrapper").removeClass("greyOut");
    };
  });

  //define form options
  const option: { [key: string]: JQuery<HTMLElement> } = {};
  const elementIds = [
    'addCampgroundInfo',
    'editCampgroundInfo',
    'addCG_staff',
    'addCG_nonstaff',
    'editCG_staff',
    'editCG_nonstaff',
    'editCG_dup_closed_camp',
    'editCG_incorrect_data',
    'editCG_duplicate',
    'editCG_permclosed',
    'editCG_tempclosed',
    'editCG_moved',
    'editCG_notacamp'
  ];
  elementIds.forEach((id) => {
    option[id] = $(`#${id}`);
  });

  // Define groups of elements that will toggle each other's active state
  const toggleGroups = [
    ['addCampgroundInfo', 'editCampgroundInfo'],
    ['addCG_staff', 'addCG_nonstaff'],
    ['editCG_staff', 'editCG_nonstaff'],
    ['editCG_dup_closed_camp', 'editCG_incorrect_data'],
    ['editCG_duplicate', 'editCG_permclosed', 'editCG_tempclosed', 'editCG_moved', 'editCG_notacamp']
  ];

  // Attach click events for radio functionality
  toggleGroups.forEach(group => {
    group.forEach(activeId => {
      option[activeId].on("click", function () {
        const not_active = group.filter(id => id !== activeId).map(id => option[id]);
        toggleActiveState(option[activeId], not_active);
      });
    });
  });

  const hiddenContent_duplicate = $('#editCG_closedmoved_wrapper');
  const hiddenContent_incorrectdata = $('#editCG_incorrectdata_wrapper');
  const hiddenContent_duplicate_camp = $('#editCG_duplicatecamp_wrapper');
  const hiddenContent_moved_camp = $('#editCG_moved_wrapper');
  const hiddenContent_permClosed = $('#editCG_permClosed_wrapper');
  const hiddenContent_tempClosed = $('#editCG_tempClosed_wrapper');
  const hiddenContent_notCamp = $('#editCG_notacamp_wrapper');

  // If option['editCG_incorrect_data'] is clicked, show hiddenContent_incorrectdata and hide hiddenContent_duplicate
  option['editCG_incorrect_data'].on("click", function () {
    hiddenContent_incorrectdata.removeClass('greyOut');
    hiddenContent_incorrectdata.removeClass('d-none');
    hiddenContent_duplicate.addClass('d-none');
    hiddenContent_notCamp.addClass('d-none');
    hiddenContent_permClosed.addClass('d-none');
    hiddenContent_tempClosed.addClass('d-none');
    hiddenContent_moved_camp.addClass('d-none');
    hiddenContent_duplicate_camp.addClass('d-none');
  });
  // If option['editCG_duplicate'] is clicked, show hiddenContent_duplicate and hide hiddenContent_incorrectdata
  option['editCG_dup_closed_camp'].on("click", function () {
    hiddenContent_duplicate.removeClass('d-none');
    hiddenContent_incorrectdata.addClass('d-none');
  });

  // If option['editCG_duplicate'] is clicked, show hiddenContent_duplicate_camp
  option['editCG_duplicate'].on("click", function () {
    hiddenContent_duplicate_camp.removeClass('d-none');
    hiddenContent_moved_camp.addClass('d-none');
    hiddenContent_permClosed.addClass('d-none');
    hiddenContent_tempClosed.addClass('d-none');
    hiddenContent_notCamp.addClass('d-none');
  });
  // If option['editCG_moved'] is clicked show hiddenContent_moved_camp
  option['editCG_moved'].on("click", function () {
    hiddenContent_moved_camp.removeClass('d-none');
    hiddenContent_duplicate_camp.addClass('d-none');
    hiddenContent_permClosed.addClass('d-none');
    hiddenContent_tempClosed.addClass('d-none');
    hiddenContent_notCamp.addClass('d-none');
    if($("#editCG_moved_wrapper").length > 0){
      get_form_wrongLoc_fromID($("#reportBadData").attr("campID")).then((response) =>{
        const visibleMovedWrapper = $("#editCG_moved_wrapper").filter(":visible");
        visibleMovedWrapper.html(response);
      }).catch((e) => {
        const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
        $("#errorModal").modal("show");
      });
    }
  });
  // If option['editCG_permclosed'] is clicked, show hiddenContent_permClosed
  option['editCG_permclosed'].on("click", function () {
    hiddenContent_permClosed.removeClass('d-none');
    hiddenContent_tempClosed.addClass('d-none');
    hiddenContent_duplicate_camp.addClass('d-none');
    hiddenContent_moved_camp.addClass('d-none');
    hiddenContent_notCamp.addClass('d-none');
  });
  // If option['editCG_tempclosed'] is clicked, show hiddenContent_tempClosed
  option['editCG_tempclosed'].on("click", function () {
    hiddenContent_tempClosed.removeClass('d-none');
    hiddenContent_permClosed.addClass('d-none');
    hiddenContent_duplicate_camp.addClass('d-none');
    hiddenContent_moved_camp.addClass('d-none');
    hiddenContent_notCamp.addClass('d-none');
  });
  // If option['editCG_notacamp'] is clicked, show hiddenContent_notCamp
  option['editCG_notacamp'].on("click", function () {
    hiddenContent_notCamp.removeClass('d-none');
    hiddenContent_permClosed.addClass('d-none');
    hiddenContent_duplicate_camp.addClass('d-none');
    hiddenContent_moved_camp.addClass('d-none');
    hiddenContent_tempClosed.addClass('d-none');
  });

  // Get the campground ID from the URL
  const campgroundId = urlParams.get("campID");


  // If the campground ID exists, get the campground name and set the search input placeholder to it
  if (campgroundId) {
    const campgroundName = $("#campgroundName").text();
    $("#search_query").attr("placeholder", `${campgroundName}`);
  }

  //
  //-AUTOFILL CODE
  //
  // When an element with the attribute "exampleSearch" is clicked, set the value of the search_query input to the clicked element's HTML and trigger a click event on the submit_search_query button.
  //- Don't believe this is triggered - can most likely remove
  // $(document).on("click", "[exampleSearch]", function() {
  //   $("#search_query").val($(this).html());
  //   $("#submit_search_query").trigger("click");
  // });

  $(document).on("click", "#editCampgroundInfo", function(){
    $("#editCampground_checkfor_selectedcamp_wrapper").removeClass("greyOut");
  });

  // When the search_query input is clicked, check if it is empty. If it is, hide the autofill suggestions and show the base suggestions. If it is not empty, show the autofill suggestions and hide the base suggestions.
  $(document).on("click", "#search_query", ()=>{
      let query:string | null;
      let queryEl: HTMLElement | null = document.getElementById('search_query');
      if (queryEl instanceof HTMLInputElement) {
      query = queryEl.value;
      };
      if (query.length < 1 || $('#search_query').val() == '') {
        //checking if input box is empty
        $(".autofillOuterWrap").addClass("d-none");
        $("#autofill_results").html("");
        if(!($('.autofillOuterWrap').is(':visible'))){
            $("#baseSuggestions").removeClass("d-none");
        }
        return;
      }else{
        $(".autofillOuterWrap").removeClass("d-none");
        $("#baseSuggestions").addClass("d-none");
      };
  });

  // When the search_query input loses focus, hide the base suggestions.
  $("#search_query").blur(function(){
    $("#baseSuggestions").addClass("d-none");
  });

  // When the search_query input is changed, check if it is empty and has no text selected. If it is, hide the autofill suggestions and show the base suggestions.
  $(document).on("input", "#search_query", function(){
    var inputValue = $(this).val();
    var selectionStart = this.selectionStart;
    var selectionEnd = this.selectionEnd;
    if (inputValue.toString().length === 0 && selectionStart === 0 && selectionEnd === inputValue.toString().length) {
      $(".autofillOuterWrap").addClass("d-none");
      $("#autofill_results").html("");
      if(!($('.autofillOuterWrap').is(':visible'))){
        $("#baseSuggestions").removeClass("d-none");
      }
    }
  });

  // When a key is released in the search_query input, check if the Enter key or Backspace key was pressed. If the Enter key was pressed, trigger the campground_search function and scroll to the results. If the Backspace key was pressed and the search_query input is empty, hide the autofill suggestions and show the base suggestions. Otherwise, get the search suggestions for the current query and show them in the autofill suggestions.
  $(document).on("keyup", "#search_query", (event: JQuery.KeyUpEvent<any, any, any, any>)=>{
    if (event.key == "Enter") {
      //No search bc we're relying on autofill here
      //campground_search();
      //No scroll bc no results
      //cgScrollToResults();
    } else if(event.key == "Backspace"){
      $("#search_query").removeAttr("query_type");
      $("#search_query").removeAttr("query_val");
      if($('#search_query').val() == '' || $('#search_query').val().toString().length == 1){
        $(".autofillOuterWrap").addClass("d-none");
        $("#autofill_results").html("");
        if(!($('.autofillOuterWrap').is(':visible'))){
          $("#baseSuggestions").removeClass("d-none");
        }
      }
    } else {
      let query:string | null;
        let queryEl: HTMLElement | null = document.getElementById('search_query');
      $("#search_query").removeAttr("query_type");
      $("#search_query").removeAttr("query_val");
      if (queryEl instanceof HTMLInputElement) {
        query = queryEl.value;
      };
      if (query.length < 1 || $('#search_query').val() == '') {
        //checking if input box is empty
        $(".autofillOuterWrap").addClass("d-none");
        $("#autofill_results").html("");
        if(!($('.autofillOuterWrap').is(':visible'))){
          $("#baseSuggestions").removeClass("d-none");
        }
        return;
      }else{
        $(".autofillOuterWrap").removeClass("d-none");
        $("#baseSuggestions").addClass("d-none");
      };
      //need to rewrite a custom suggestions for camps only
      //getSearchSuggestions(query).then((response) =>{
      getSearchSuggestions_CIU(query).then((response) =>{
        $("#autofill_results").html(response);
      }).catch((e) => {
        const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
        $("#errorModal").modal("show");
      });
    }
  });

  // When the submit_search_query button is clicked, trigger the campground_search function and scroll to the results.
  //This isn't needed bc we're relying on autofill
  // $("#submit_search_query").on("click", function(event){
  //   campground_search();
  //   // send_cg_search();
  //   cgScrollToResults();
  // });

  // When a search suggestion is clicked, set the search_query input value to the suggestion's query_str attribute, and set the search_query input's query_type and query_val attributes to the suggestion's query_type and query_val attributes, respectively. Then, show the side filters and sort by options, and get the search suggestions for the selected suggestion.
  $(document).on("click",".search-suggestion",(event: { currentTarget: any; }) => {
    let element = $(event.currentTarget);

    let query:string = element.attr("query_str");
    let query_type:string = element.attr("query_type");
    let query_val:string = element.attr("query_val");
    // $("#camp_search_loading").html(loadingIcon);
    //change url to /campgroundInfoUpdate?query_val
    window.history.pushState({}, '', "/campgroundInfoUpdate?campID="+query_val);
    autofill_click_log(query_type,query_val);

    //temporary if to only allow camp_name queries through
    if(query_type == "camp_name"){
      $("#search_query").val(query);
      $("#search_query").attr("query_type",query_type);
      $("#search_query").attr("query_val",query_val);

      $('#sidefilters').removeClass('d-none');
        $("#sortBy_cgSearchWrapper").removeClass("d-none");

      //NONONO we're just gonna take the query_val which should be the campID and deal with that.
      //send_autofill_search_and_handle_response(query_type,query_val);
      $(".autofillOuterWrap").addClass("d-none");
      $("#editCampground_checkfor_selectedcamp_wrapper").removeClass("greyOut");

      if($("#dataForm_nocamp").length > 0){
        get_form_fromID(query_val).then((response) =>{
          //removed visibility check - might need to play w later
          const visibleDataForm = $("#dataForm_nocamp");
          visibleDataForm.html(response);
        }).catch((e) => {
          const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
          $("#errorModal").modal("show");
        });
      }
    }
  });


  //ADD LISTENER FOR #editCG_addImage and #addCG_addImage that will show the modal #campReportAddImageModal
  $(document).on("click", "#editCG_addImage", function(){
    $("#campReportAddImageModal").modal("show");
  });
  $(document).on("click", "#addCG_addImage", function(){
    $("#campReportAddImageModal").modal("show");
  });

  //ADD LISTENERS that checks if either (#editCG_staff or #editCG_nonstaff is clicked) OR (#addCG_staff or #addCG_nonstaff is clicked)
  //and then if either is it removed .greyOut from the appropriate wrapper (either #editCG_dup_closed_incorrect_wrapper or #addCG_staffGreyOut_wrapper)
  $(document).on("click", "#editCG_staff, #editCG_nonstaff", function(){
    $("#editCG_dup_closed_incorrect_wrapper").removeClass("greyOut");
  });

  $(document).on("click", "#addCG_staff, #addCG_nonstaff", function(){
    $("#addCG_staffGreyOut_wrapper").removeClass("greyOut");
  });

  //CHECK FORM SUBMIT FOR #editCG_duplicatecamp_wrapper
  $(document).on("submit", "#editCG_duplicatecamp_wrapper", function(event){
    event.preventDefault();
    const urlParams = new URLSearchParams(window.location.search);
    let staff: Record<string,string[]> = {};

    if($("#editCG_staff").hasClass("active")){
      staff["staffqprompt"] = ["staff"];
    }else if($("#editCG_nonstaff").hasClass("active")){
      staff["staffqprompt"] = ["nonstaff"];
    };

    $.ajax({
      type: "post",
      url: "/reportDuplicateCamp",
      data: JSON.stringify({
        staff:staff,
        "campID":urlParams.get("campID"),
        "campName":$("#editCG_duplicatecamp_input").val().toString()
      }),
      contentType: "application/json",
      dataType: "text",
      success: function(data) {
        $("#campReportThanks").modal("show");
        // Listen for the modal to be hidden
        $("#campReportThanks").on("hidden.bs.modal", function () {
          // Refresh the page
          location.reload();
        });
      },
      error: function(xhr,errStr,exc) {
        $("#exception_str").val(errStr);
        $("#errorModal").modal("show");
      }
    });
  });

  //CHECK FORM SUBMIT FOR #editCG_permClosed_wrapper
  $(document).on("submit", "#editCG_permClosed_wrapper", function(event){
    event.preventDefault();
    const urlParams = new URLSearchParams(window.location.search);
    let staff: Record<string,string[]> = {};

    if($("#editCG_staff").hasClass("active")){
      staff["staffqprompt"] = ["staff"];
    }else if($("#editCG_nonstaff").hasClass("active")){
      staff["staffqprompt"] = ["nonstaff"];
    };

    $.ajax({
      type: "post",
      url: "/reportPermClosed",
      data: JSON.stringify({
        staff:staff,
        "campID":urlParams.get("campID")
      }),
      contentType: "application/json",
      dataType: "text",
      success: function(data) {
        $("#campReportThanks").modal("show");
        // Listen for the modal to be hidden
        $("#campReportThanks").on("hidden.bs.modal", function () {
          // Refresh the page
          location.reload();
        });
      },
      error: function(xhr,errStr,exc) {
        $("#exception_str").val(errStr);
        $("#errorModal").modal("show");
      }
    });
  });

  //CHECK FORM SUBMIT FOR #editCG_tempClosed_wrapper
  $(document).on("submit", "#editCG_tempClosed_wrapper", function(event){
    event.preventDefault();
    const urlParams = new URLSearchParams(window.location.search);
    let staff: Record<string,string[]> = {};

    if($("#editCG_staff").hasClass("active")){
      staff["staffqprompt"] = ["staff"];
    }else if($("#editCG_nonstaff").hasClass("active")){
      staff["staffqprompt"] = ["nonstaff"];
    };

    $.ajax({
      type: "post",
      url: "/reportTempClosed",
      data: JSON.stringify({
        staff:staff,
        "campID":urlParams.get("campID")
      }),
      contentType: "application/json",
      dataType: "text",
      success: function(data) {
        $("#campReportThanks").modal("show");
        // Listen for the modal to be hidden
        $("#campReportThanks").on("hidden.bs.modal", function () {
          // Refresh the page
          location.reload();
        });
      },
      error: function(xhr,errStr,exc) {
        $("#exception_str").val(errStr);
        $("#errorModal").modal("show");
      }
    });
  });

  //CHECK FORM SUBMIT FOR #editCG_notacamp_wrapper
  $(document).on("submit", "#editCG_notacamp_wrapper", function(event){
    event.preventDefault();
    const urlParams = new URLSearchParams(window.location.search);
    let staff: Record<string,string[]> = {};

    if($("#editCG_staff").hasClass("active")){
      staff["staffqprompt"] = ["staff"];
    }else if($("#editCG_nonstaff").hasClass("active")){
      staff["staffqprompt"] = ["nonstaff"];
    };

    $.ajax({
      type: "post",
      url: "/reportNotACamp",
      data: JSON.stringify({
        staff:staff,
        "campID":urlParams.get("campID")
      }),
      contentType: "application/json",
      dataType: "text",
      success: function(data) {
        $("#campReportThanks").modal("show");
        // Listen for the modal to be hidden
        $("#campReportThanks").on("hidden.bs.modal", function () {
          // Refresh the page
          location.reload();
        });
      },
      error: function(xhr,errStr,exc) {
        $("#exception_str").val(errStr);
        $("#errorModal").modal("show");
      }
    });
  });

  $(document).on("submit", "#reportNewLocation", function(event){
    event.preventDefault();
    const urlParams = new URLSearchParams(window.location.search);
    let newCampData: Record<string,string> = {
      name: $("#camp_name_wl").val().toString(),
      address: $("#street_address_wl").val().toString(),
      city: $("#city_wl").val().toString(),
      state: $("#administrative_area_level_1_wl").val().toString(),
      campID: urlParams.get("campID")
    };
    let staff: Record<string,string[]> = {};

    if($("#editCG_staff").hasClass("active")){
      staff["staffqprompt"] = ["staff"];
    }else if($("#editCG_nonstaff").hasClass("active")){
      staff["staffqprompt"] = ["nonstaff"];
    };

    $.ajax({
      type: "post",
      url: "/reportNewCamp_location",
      data: JSON.stringify({
        campData:newCampData,
        staff:staff
      }),
      contentType: "application/json",
      dataType: "text",
      success: function(data) {
        $("#campReportThanks").modal("show");
        // Listen for the modal to be hidden
        $("#campReportThanks").on("hidden.bs.modal", function () {
          // Refresh the page
          location.reload();
        });
      },
      error: function(xhr,errStr,exc) {
        $("#exception_str").val(errStr);
        $("#errorModal").modal("show");
      }
    });
  });

  //check that #camp_name has been interacted with/a user has put a value in it and if they have removed the greyOut-5 class from
  //the #addCG_addImage button. Also add greyOut class to #needMoreData_warning_addImage if #camp_name has been interacted with
  $(document).on("input", "#camp_name", function(){
    if ($(this).val().toString().trim() !== "") {
      $("#addCG_addImage").removeClass("greyOut-5");
      $("#needMoreData_warning_addImage").addClass("greyOut");
    } else {
      $("#addCG_addImage").addClass("greyOut-5");
      $("#needMoreData_warning_addImage").removeClass("greyOut");
    }
  });

  $(document).on("submit", "#reportNewCamp", function(event){
    event.preventDefault();
    let newCampData: Record<string,string> = {
      camp_name: $("#camp_name").val().toString(),
      street_address: $("#street_address").val().toString(),
      city: $("#city").val().toString(),
      administrative_area_level_1: $("#administrative_area_level_1").val().toString(),
      description: $("#description").val().toString(),
      site_url: $("#site_url").val().toString(),
      num_sites: $("#num_sites").val().toString(),
      open_date: $("#open_date").val().toString(),
      close_date: $("#close_date").val().toString(),
      max_RV_length: $("#max_RV_length").val().toString(),
      max_RV_width: $("#max_RV_width").val().toString(),
      max_RV_height: $("#max_RV_height").val().toString(),
      price_low: $("#price_low").val().toString(),
      price_high: $("#price_high").val().toString(),
      email: $("#email").val().toString(),
      info_phone: $("#info_phone").val().toString(),
      reserve_phone: $("#reserve_phone").val().toString(),
      reserve_url: $("#reserve_url").val().toString(),
      facebook: $("#facebook").val().toString(),
      instagram: $("#instagram").val().toString(),
      twitter: $("#twitter").val().toString(),
      pinterest: $("#pinterest").val().toString(),
      youtube: $("#youtube").val().toString(),
      otherSuggestion: $("#otherSuggestion").val().toString()
    };
    let newFeatures: Record<string,string[]> = {};
    let remFeatures: Record<string,string[]> = {};
    let staff: Record<string,string[]> = {};

    if($("#addCG_staff").hasClass("active")){
      staff["staffqprompt"] = ["staff"];
    }else if($("#addCG_nonstaff").hasClass("active")){
      staff["staffqprompt"] = ["nonstaff"];
    };

    $(".data-form-input").each(function(this) {
      //only care about data that has been changed, added, or removed
      if ($(this).prop("type") == "checkbox") {
        //User said this campground has an amenity that our DB says it does not
        if ($(this).prop("checked") && $(this).attr("current_value").toString() == "0") {
          //append this feature to list of new features, or create that list if it is undefined
          if (newFeatures[$(this).attr("feature_type")] == undefined) {
            newFeatures[$(this).attr("feature_type")] = [$(this).attr("id")];
          } else {
            newFeatures[$(this).attr("feature_type")].push($(this).attr("id"));
          };

        //User said this campground does not have an amenity that our DB says it does
        } else if ((!($(this).prop("checked"))) && $(this).attr("current_value").toString() == "1") {
          if (remFeatures[$(this).attr("feature_type")] == undefined) {
            remFeatures[$(this).attr("feature_type")] = [$(this).attr("id")];
          } else {
            remFeatures[$(this).attr("feature_type")].push($(this).attr("id"));
          };
        };
      } else if (($(this).val().toString().length > 0 || $(this).attr("current_value").toString().length > 0) && ($(this).val() != $(this).attr("current_value"))) {
        newCampData[$(this).attr("id").toString()] = $(this).val().toString();
      };
    });

    $.ajax({
      type: "post",
      url: "/reportNewCamp",
      data: JSON.stringify({
        campData:newCampData,
        newFeatures:newFeatures,
        remFeatures:remFeatures,
        staff:staff
      }),
      contentType: "application/json",
      dataType: "text",
      success: function(data) {
        $("#campReportThanks").modal("show");
        // Listen for the modal to be hidden
        $("#campReportThanks").on("hidden.bs.modal", function () {
          // Refresh the page
          location.reload();
        });
      },
      error: function(xhr,errStr,exc) {
        $("#exception_str").val(errStr);
        $("#errorModal").modal("show");
      }
    });
  });
}

export const get_form_fromID = async (campID:string) => {
	let success:boolean = false;
	let responseHTML:string;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "/campgroundInfoUpdate_getForm",
		data: JSON.stringify({
			campID:campID
		}),
		contentType: "application/json",
		dataType: "text",
		success: (data) => {
			responseHTML = data;
			success = true;
		},
		error: function(xhr,errStr,exc) {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<string>((resolve,reject) => {
		if (success) resolve(responseHTML);
		else reject(Error(errMsg));
	});
};

export const get_form_wrongLoc_fromID = async (campID:string) => {
	let success:boolean = false;
	let responseHTML:string;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "/campgroundInfoUpdate_getForm_wrongLoc",
		data: JSON.stringify({
			campID:campID
		}),
		contentType: "application/json",
		dataType: "text",
		success: (data) => {
			responseHTML = data;
			success = true;
		},
		error: function(xhr,errStr,exc) {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<string>((resolve,reject) => {
		if (success) resolve(responseHTML);
		else reject(Error(errMsg));
	});
};


//OLD ONLY 2 PAIR OPTION
// function toggleActiveState(active:any, not_active:any) {
//   //set active states
//   active.addClass("active");
//   not_active.removeClass("active");

//   //deal with icon visuals
//   removeClass_ai_icons(active.children("i"));
//   active.children("i").addClass("active").removeClass("opacity-50").addClass("ai-circle-check-filled");
//   removeClass_ai_icons(not_active.children("i"));
//   not_active.children("i").removeClass("active").addClass("opacity-50").addClass("ai-circle-minus");
//   updateCampgroundInfoContent();
// }

function toggleActiveState(active: any, not_active: any[]) {
  // Set the active state for the active element
  active.addClass("active");
  removeClass_ai_icons(active.children("i"));
  active.children("i").addClass("active").removeClass("opacity-50").addClass("ai-circle-check-filled");

  // Loop through the array of elements that should not be active
  not_active.forEach((element) => {
    element.removeClass("active");
    removeClass_ai_icons(element.children("i"));
    element.children("i").removeClass("active").addClass("opacity-50").addClass("ai-circle-minus");
  });

  // Update the content, assuming updateCampgroundInfoContent() is applicable for multiple cases
  updateCampgroundInfoContent();
}


function removeClass_ai_icons(inputElement: JQuery<HTMLElement>): void {
  // Get the class list of the first element in the jQuery object
  const classList = inputElement.attr('class')?.split(/\s+/) || [];
  // Iterate through each class name
  classList.forEach((className: string) => {
    // Check if the class name starts with 'ai-'
    if (className.startsWith('ai-')) {
      // Remove the class from the jQuery element
      inputElement.removeClass(className);
    }
  });
}


function updateCampgroundInfoContent(){
  const addCampgroundContent = $("#addCampgroundContent");
  const editCampgroundContent = $("#editCampgroundContent");

  if ($("#addCampgroundInfo").hasClass("active")) {
    addCampgroundContent.removeClass("d-none");
    editCampgroundContent.addClass("d-none");
  } else {
    editCampgroundContent.removeClass("d-none");
    addCampgroundContent.addClass("d-none");
  }

  if ($("#editCampgroundInfo").hasClass("active")) {
    editCampgroundContent.removeClass("d-none");
    addCampgroundContent.addClass("d-none");
  } else {
    editCampgroundContent.addClass("d-none");
    addCampgroundContent.removeClass("d-none");
  }
}